import {assetUrl} from "datnek-ds";
export const NETWORK_LOCALES = [

];
